const frameJS = require('raw-loader!~/pegasus_template/assets/landing_page_widgets.js');
const sufJS = require('raw-loader!~/pegasus_template/assets/signup_forms.js');
const formJS = require('raw-loader!~/pegasus_template/assets/form_js.js');

PegasusTemplate.InitializeSignupForms = Em.Mixin.create({
  initializeIFrames: function(){
    var frame = $( this.get('frameSelector') ),
      ready = function(){
        var bodies = $(this).contents().find('body');
        bodies.each(function(_,body) {
          var doc = body.ownerDocument;
          var script = doc.createElement("script");
          script.type = "text/javascript";
          script.textContent = frameJS;
          doc.body.appendChild(script);
        });
      };

    ready.call(frame);
  },

  initializeForms: function(){
    var frame = $( this.get('frameSelector') ),
      ready = function(){
        var bodies = $(this).contents().find('body');
        bodies.each(function(_,body) {
          var doc = body.ownerDocument;
          var win = doc.defaultView || doc.parentWindow;
          win.reallySubmit = false;

          var script = doc.createElement("script");
          script.type = "text/javascript";
          script.textContent = sufJS;
          doc.body.appendChild(script);

          var script = doc.createElement("script");
          script.type = "text/javascript";
          script.textContent = formJS;
          doc.body.appendChild(script);
        });
      };

    ready.call(frame);
  }
});
